// toggle__buttons-currency
//toggle__buttons-time


window.addEventListener('DOMContentLoaded', () => {

    const currencyButton = document.querySelectorAll('.toggle__buttons-currency input');
    const selectCurrency = document.querySelector('.select__dropdown .select__currency');
    const timeButton = document.querySelectorAll('.toggle__buttons-time input');
    const selectTime = document.querySelector('.select__dropdown .select__time');
    // pricing__table-grid
    const pricingTableGrid = document.querySelectorAll('.pricing__table-grid');
    // set data attributes to pricing__table-price - data-current-time as monthly, data-current-currency as euro
    pricingTableGrid.forEach((pricingTableGrid) => {
        pricingTableGrid.setAttribute('data-current-time', 'yearly');
        pricingTableGrid.setAttribute('data-current-currency', 'euro');
    });

    if(currencyButton){
        currencyButton.forEach((button) => {
            button.addEventListener('change', (e) => {
                // get the value of the selected button
                const currency = e.target.value;
                // get the closest parent .toggle__container, then its sibling .pricing__table-grid
                const pricingTableGrid =  e.target.closest('.pricing__container').querySelector('.pricing__table-grid');
                // get the current time value from the data attribute
                const currentTime = pricingTableGrid.getAttribute('data-current-time');
                // const currentCurrency = pricingTableGrid.getAttribute('data-current-currency');
    
                // set the data-current-currency attribute to the selected currency
                pricingTableGrid.setAttribute('data-current-currency', currency);
                // get the price element
                const price = pricingTableGrid.querySelectorAll('.pricing__table-price');
                // get the price values for the selected currency
                price.forEach((price) => {
                    const priceMonthly = price.getAttribute(`data-price-monthly-${currency}`);
                    const priceYearly = price.getAttribute(`data-price-yearly-${currency}`);
                    if(priceMonthly && priceYearly){
                        if (currentTime === 'monthly') {
                            price.textContent = priceMonthly;
                        } else {
                            price.textContent = priceYearly;
                        }
                    }
                });
            });
    
           if(timeButton){
            timeButton.forEach((button) => {
                button.addEventListener('change', (e) => {
                    // get the value of the selected button
                    const time = e.target.value;
                    // get the parent .toggle__container, then its sibling .pricing__table-grid
                    const pricingTableGrid = e.target.closest('.pricing__container').querySelector('.pricing__table-grid');
                    // get the current currency value from the data attribute
                    const currentCurrency = pricingTableGrid.getAttribute('data-current-currency');
                    // set the data-current-time attribute to the selected time
                    pricingTableGrid.setAttribute('data-current-time', time);
                    // get the price element
                    const prices = pricingTableGrid.querySelectorAll('.pricing__table-price');
                    // get the price values for the selected time
                    prices.forEach((price) => {
                        const priceMonthly = price.getAttribute(`data-price-monthly-${currentCurrency}`);
                        const priceYearly = price.getAttribute(`data-price-yearly-${currentCurrency}`);
                        if(priceMonthly && priceYearly){
                            if (time === 'monthly') {
                                price.textContent = priceMonthly;
                            } else {
                                price.textContent = priceYearly;
                            }
                        }
                       
                    });
                });
            });
           }
            
        });
    
    }
  
    if(selectCurrency === null){
        return;
    }
    selectCurrency.addEventListener('change', (e) => {
        // alert('selectCurrency');
        const currency = e.target.value;
        const pricingTableGrid = e.target.closest('.pricing__container').querySelector('.pricing__table-grid');
        const currentTime = pricingTableGrid.getAttribute('data-current-time');
        pricingTableGrid.setAttribute('data-current-currency', currency);
        const price = pricingTableGrid.querySelectorAll('.pricing__table-price');
        price.forEach((price) => {
            const priceMonthly = price.getAttribute(`data-price-monthly-${currency}`);
            const priceYearly = price.getAttribute(`data-price-yearly-${currency}`);
            if(priceMonthly && priceYearly){
                if (currentTime === 'monthly') {
                    price.textContent = priceMonthly;
                } else {
                    price.textContent = priceYearly;
                }
            }
        });
    }
    );

    if(selectTime === null){
        return;
    }
    selectTime.addEventListener('change', (e) => {
        const time = e.target.value;
        const pricingTableGrid = e.target.closest('.pricing__container').querySelector('.pricing__table-grid');
        const currentCurrency = pricingTableGrid.getAttribute('data-current-currency');
        pricingTableGrid.setAttribute('data-current-time', time);
        const prices = pricingTableGrid.querySelectorAll('.pricing__table-price');
        prices.forEach((price) => {
            const priceMonthly = price.getAttribute(`data-price-monthly-${currentCurrency}`);
            const priceYearly = price.getAttribute(`data-price-yearly-${currentCurrency}`);
            if(priceMonthly && priceYearly){
                if (time === 'monthly') {
                    price.textContent = priceMonthly;
                } else {
                    price.textContent = priceYearly;
                }
            }
        });

    });

 

});